import { COLOR } from 'app-v2/design-tokens'
import { Cancel, CheckBold } from 'app/assets/icons'
import { Text } from 'app/common/typography'
import { FormattedMessage } from 'react-intl'
import { colors as oldColors } from 'shared/assets/styles'
import { colors } from 'app-v2/design-systems/theme'
import { getOrderStatus } from 'shared/utils/ecommerce'
import styled from 'styled-components'

const { red } = oldColors

type OrderStatusProps = {
    isDelivered: boolean,
    isCancelled: boolean,
    marginTop: boolean
}

export const OrderStatus = ({
    isDelivered,
    isCancelled,
    marginTop
}: OrderStatusProps) => {
    const key = getOrderStatus(isDelivered, isCancelled)
    if (!key) {
        return null
    }
    return (
        <RowContainer marginTop={marginTop}>
            <Logo>
                {isDelivered ? (
                    <CheckBold color={colors.crunchyGreen} size={24} />
                ) : (
                    isCancelled && <Cancel color={red} size={24} />
                )}
            </Logo>
            <FormattedMessage id={key}>
                {(text: string) => <TextLogo>{text}</TextLogo>}
            </FormattedMessage>
        </RowContainer>
    )
}

const RowContainer = styled.div`
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    display: flex;
    ${props => !!props.marginTop && `margin-bottom: 10px;`}
`

const Logo = styled.div`
    padding: 0px 9px;
`

const TextLogo = styled(Text)`
    font-size: 15px;
    font-weight: 500;
    flex: 1;
    display: flex;
    padding-right: 10px;
    color: ${COLOR.PRIMARY};
    line-height: 20px;
    white-space: pre-line;
`
